var _a;
import keys from "./keys";
var translate = (_a = {},
    _a[keys.LNG_af] = "Africâner",
    _a[keys.LNG_sq] = "Albanês",
    _a[keys.LNG_ar] = "Árabe",
    _a[keys.LNG_az] = "Azerbaijano",
    _a[keys.LNG_bn] = "Bengali",
    _a[keys.LNG_bg] = "Búlgaro",
    _a[keys.LNG_ca] = "Catalão",
    _a[keys.LNG_zh_CN] = "Chinês (CHN)",
    _a[keys.LNG_zh_HK] = "Chinês (HKG)",
    _a[keys.LNG_zh_TW] = "Chinês (TAI)",
    _a[keys.LNG_hr] = "Croata",
    _a[keys.LNG_cs] = "Tcheco",
    _a[keys.LNG_da] = "Dinamarquês",
    _a[keys.LNG_nl] = "Holandês",
    _a[keys.LNG_en] = "Inglês",
    _a[keys.LNG_en_GB] = "Inglês (UK)",
    _a[keys.LNG_en_US] = "Inglês (US)",
    _a[keys.LNG_et] = "Estoniano",
    _a[keys.LNG_fil] = "Filipino",
    _a[keys.LNG_fi] = "Finlandês",
    _a[keys.LNG_fr] = "Francês",
    _a[keys.LNG_de] = "Alemão",
    _a[keys.LNG_el] = "Grego",
    _a[keys.LNG_gu] = "Gujarati",
    _a[keys.LNG_ha] = "Hausa",
    _a[keys.LNG_he] = "Hebraico",
    _a[keys.LNG_hi] = "Hindi",
    _a[keys.LNG_hu] = "Húngaro",
    _a[keys.LNG_id] = "Indonésio",
    _a[keys.LNG_ga] = "Irlandês",
    _a[keys.LNG_it] = "Italiano",
    _a[keys.LNG_ja] = "Japonês",
    _a[keys.LNG_kn] = "Canarês",
    _a[keys.LNG_kk] = "Cazaque",
    _a[keys.LNG_ko] = "Coreano",
    _a[keys.LNG_lo] = "Laosiano",
    _a[keys.LNG_lv] = "Letão",
    _a[keys.LNG_lt] = "Lituano",
    _a[keys.LNG_mk] = "Macedônio",
    _a[keys.LNG_ms] = "Malaio",
    _a[keys.LNG_ml] = "Malayalam",
    _a[keys.LNG_mr] = "Marathi",
    _a[keys.LNG_nb] = "Norueguês",
    _a[keys.LNG_fa] = "Persa",
    _a[keys.LNG_pl] = "Polonês",
    _a[keys.LNG_pt_BR] = "Português (BR)",
    _a[keys.LNG_pt_PT] = "Português (POR)",
    _a[keys.LNG_pa] = "Punjabi",
    _a[keys.LNG_ro] = "Romeno",
    _a[keys.LNG_ru] = "Russo",
    _a[keys.LNG_sr] = "Sérvio",
    _a[keys.LNG_sk] = "Eslovaco",
    _a[keys.LNG_sl] = "Esloveno",
    _a[keys.LNG_es] = "Espanhol",
    _a[keys.LNG_es_AR] = "Espanhol (ARG)",
    _a[keys.LNG_es_ES] = "Espanhol (ESP)",
    _a[keys.LNG_es_MX] = "Espanhol (MEX)",
    _a[keys.LNG_sw] = "Suaíli",
    _a[keys.LNG_sv] = "Sueco",
    _a[keys.LNG_ta] = "Tâmil",
    _a[keys.LNG_te] = "Telugu",
    _a[keys.LNG_th] = "Tailandês",
    _a[keys.LNG_tr] = "Turco",
    _a[keys.LNG_uk] = "Ucraniano",
    _a[keys.LNG_ur] = "Urdu",
    _a[keys.LNG_uz] = "Usbeque",
    _a[keys.LNG_vi] = "Vietnamita",
    _a[keys.LNG_zu] = "Zulu",
    _a);
export default translate;
//# sourceMappingURL=data:application/json;base64,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